
import { SVG, Path } from "@wordpress/components";

const Header = (props) => {
  return (
    <div className="integration-toolkit-for-beehiiv-settings-header" key="settings-header">
      <div className="integration-toolkit-for-beehiiv-settings-header__logo">
        Integration Toolkit for beehiiv
      </div>

      <div className="integration-toolkit-for-beehiiv-settings-header__links">
      </div>
    </div>
  );
};

export default Header;
